export default {"src":"/_next/static/media/cold-plunge.21791dc3.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};